import React, { Component } from "react";
import { Button, Paper } from "@material-ui/core";
import { GetUserLogin } from "../../../../services";
import { NotificationManager } from "react-notifications";
import Loader from "../../../../loader";

export default class Create extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoaded: false,
      id: null,
      fullName: "",
      email: "",
      phone: "",
      password: "",
      confirmPassword: "",
      status: "0", // default inactive
      role: "",
    };
  }

  handleChange(e) {
    this.setState({ [e.target.name]: e.target.value });
  }

  handleBack() {
    this.props.history.goBack();
  }

  handleSubmit = async () => {
    this.setState({ isLoaded: true });

    const { fullName, phone, email, password, confirmPassword, status, role } =
      this.state;

    if (password !== confirmPassword) {
      alert("Passwords don't match");
      this.setState({ isLoaded: false });
      return;
    }

    const data = {
      fullName,
      phone,
      email,
      password,
      status: status === "1", // convert to boolean
      role,
    };

    const user = await GetUserLogin.getUserRegister(data);
    this.setState({ isLoaded: false });

    if (user) {
      NotificationManager.success("User created successfully", "Message");
      this.props.history.goBack();
    } else {
      NotificationManager.error("Check Input field!", "Input");
    }
  };

  render() {
    const {
      isLoaded,
      fullName,
      email,
      phone,
      role,
      confirmPassword,
      password,
      status,
    } = this.state;

    return (
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-5 col-md-9">
            <h2 className="mt-30 page-title">Create New User</h2>
          </div>
          <div className="col-lg-5 col-md-3 back-btn">
            <Button variant="contained" onClick={() => this.handleBack()}>
              <i className="fas fa-arrow-left" /> Back
            </Button>
          </div>
        </div>
        <ol className="breadcrumb mb-30">
          <li className="breadcrumb-item">Dashboard</li>
          <li className="breadcrumb-item">User</li>
        </ol>

        <Paper className="user-management" style={{ padding: "1rem" }}>
          {isLoaded && <Loader />}

          <div className="row">
            <div className="col-md-6 form-group">
              <label>Full Name</label>
              <input
                type="text"
                className="form-control"
                name="fullName"
                value={fullName}
                onChange={(e) => this.handleChange(e)}
              />
            </div>

            <div className="col-md-6 form-group">
              <label>Phone</label>
              <input
                type="text"
                className="form-control"
                name="phone"
                value={phone}
                onChange={(e) => this.handleChange(e)}
                maxLength="10"
              />
            </div>

            <div className="col-md-6 form-group">
              <label>Email</label>
              <input
                type="email"
                className="form-control"
                name="email"
                value={email}
                onChange={(e) => this.handleChange(e)}
              />
            </div>

            <div className="col-md-6 form-group">
              <label>Status</label>
              <select
                className="form-control"
                name="status"
                value={status}
                onChange={(e) => this.handleChange(e)}
              >
                <option value="">Select Status</option>
                <option value="1">Active</option>
                <option value="0">Inactive</option>
              </select>
            </div>

            <div className="col-md-6 form-group">
              <label>Role</label>
              <select
                className="form-control"
                name="role"
                value={role}
                onChange={(e) => this.handleChange(e)}
              >
                <option value="">Select Role</option>
                <option value="admin">Admin</option>
                <option value="HR">HR</option>
                <option value="customercare">Customer Care</option>
                <option value="operation">Operation</option>
                <option value="emp">Emp</option>
              </select>
            </div>

            <div className="col-md-6 form-group">
              <label>Password</label>
              <input
                type="password"
                className="form-control"
                name="password"
                value={password}
                onChange={(e) => this.handleChange(e)}
              />
            </div>

            <div className="col-md-6 form-group">
              <label>Confirm Password</label>
              <input
                type="password"
                className="form-control"
                name="confirmPassword"
                value={confirmPassword}
                onChange={(e) => this.handleChange(e)}
              />
            </div>
          </div>

          <button
            className="btn btn-primary col-sm-3 mt-3 py-2"
            onClick={this.handleSubmit}
          >
            Save
          </button>
        </Paper>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/admin/view/user/create/index.js